var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("li", { staticClass: "item" }, [
    _c("a", { staticClass: "item__link" }, [
      _c("div", { staticClass: "item__col-left" }, [
        _c(
          "h3",
          { staticClass: "item__title" },
          [_vm._v("\n                " + _vm._s(_vm.title)), _vm._t("title")],
          2
        ),
        _vm.$slots.id
          ? _c("div", { staticClass: "item__id" }, [_vm._t("id")], 2)
          : _vm._e(),
        _c("div", { staticClass: "item__desc" }, [_vm._t("default")], 2)
      ]),
      _vm.$slots["right-title"] || _vm.$slots["right-desc"]
        ? _c("div", { staticClass: "item__col-right" }, [
            _c(
              "div",
              { staticClass: "item__title" },
              [_vm._t("right-title")],
              2
            ),
            _c("div", { staticClass: "item__desc" }, [_vm._t("right-desc")], 2)
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }